import { render, staticRenderFns } from "./LocalChanger.vue?vue&type=template&id=2dbec398&scoped=true&"
import script from "./LocalChanger.vue?vue&type=script&lang=js&"
export * from "./LocalChanger.vue?vue&type=script&lang=js&"
import style0 from "../../assets/flags.css?vue&type=style&index=0&id=2dbec398&scoped=true&lang=css&"
import style1 from "./LocalChanger.vue?vue&type=style&index=1&id=2dbec398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbec398",
  null
  
)

export default component.exports